module.exports = __webpack_public_path__ + "static/media/de.c4f6b2e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/de.svg
// module id = 1440
// module chunks = 0